import { SelectComponent } from "@/common/components";
import useTrans from "@/hooks/useTrans";
import { useCartContext } from "@/setup/cartProvider";
import React from "react";

export default function PickerDVVC() {
  const { setDonViVanChuyen, listDVVC } = useCartContext();
  const trans = useTrans();
  const onChangeValue = (value) => {
    const dvvcSelected = listDVVC.find((item) => value === item?.ma_dv_vc);
    if (dvvcSelected?.ma_dv_vc) {
      setDonViVanChuyen(dvvcSelected);
    }
  };

  return (
    <SelectComponent
      data={listDVVC}
      valueKey="ma_dv_vc"
      labelKey="ten_kh"
      placeholder={trans?.cart.typeShip}
      onChange={onChangeValue}
      autoSelectDefault
    />
  );
}
